import { useEffect as t } from "react";
const n = (e) => {
  (e.ctrlKey || e.metaKey) && (e.key === "=" || e.key === "+" || e.key === "-" || e.key === "0" || e.code === "Equal" || e.code === "Minus" || e.code === "Digit0") && e.preventDefault();
}, r = (e) => {
  e.ctrlKey && e.preventDefault();
}, s = () => {
  t(() => {
    const e = (o) => o.preventDefault();
    return document.addEventListener("gesturestart", e), document.addEventListener("gesturechange", e), document.addEventListener("gestureend", e), () => {
      document.removeEventListener("gesturestart", e), document.removeEventListener("gesturechange", e), document.removeEventListener("gestureend", e);
    };
  }, []), t(() => (document.addEventListener("keydown", n), () => {
    document.removeEventListener("keydown", n);
  }), []), t(() => (window.addEventListener("wheel", r, { passive: !1 }), () => {
    window.removeEventListener("wheel", r);
  }), []);
}, u = s;
export {
  u as default
};
//# sourceMappingURL=use-zoom-disable.js.map
